import store from '../store'
import wx from 'weixin-js-sdk'
import {isIos} from '@/utils'
import system from '../api/system'

let isFirst = true;

// 微信签名随机字符串
const randomChar = function () {
  let nonceStr = ''
  let character = '0123456789qwertyuioplkjhgfdsazxcvbnm'
  for (let i = 0; i < 16; i++) {
    nonceStr += character[Math.ceil(Math.random() * 36)]
  }
  return nonceStr
}

/*
    @nname  sha1加密函数
    @desc   sha1加密函数
    @params
            s string
*/
const sha1 = function (s) {
  // 字符转码
  const _encodeUTF8 = function (s) {
    var i,
      c,
      x,
      r = []
    for (i = 0; i < s.length; i++)
      if ((c = s.charCodeAt(i)) < 0x80) r.push(c)
      else if (c < 0x800) r.push(0xc0 + ((c >> 6) & 0x1f), 0x80 + (c & 0x3f))
      else {
        if ((x = c ^ 0xd800) >> 10 == 0)
        //对四字节UTF-16转换为Unicode
          (c = (x << 10) + (s.charCodeAt(++i) ^ 0xdc00) + 0x10000),
            r.push(0xf0 + ((c >> 18) & 0x7), 0x80 + ((c >> 12) & 0x3f))
        else r.push(0xe0 + ((c >> 12) & 0xf))
        r.push(0x80 + ((c >> 6) & 0x3f), 0x80 + (c & 0x3f))
      }
    return r
  }

  var data = new Uint8Array(_encodeUTF8(s))
  var i, j, t
  var l = (((data.length + 8) >>> 6) << 4) + 16,
    s = new Uint8Array(l << 2)
  s.set(new Uint8Array(data.buffer)), (s = new Uint32Array(s.buffer))
  for (t = new DataView(s.buffer), i = 0; i < l; i++) s[i] = t.getUint32(i << 2)
  s[data.length >> 2] |= 0x80 << (24 - (data.length & 3) * 8)
  s[l - 1] = data.length << 3
  var w = [],
    f = [
      function () {
        return (m[1] & m[2]) | (~m[1] & m[3])
      },
      function () {
        return m[1] ^ m[2] ^ m[3]
      },
      function () {
        return (m[1] & m[2]) | (m[1] & m[3]) | (m[2] & m[3])
      },
      function () {
        return m[1] ^ m[2] ^ m[3]
      }
    ],
    rol = function (n, c) {
      return (n << c) | (n >>> (32 - c))
    },
    k = [1518500249, 1859775393, -1894007588, -899497514],
    m = [1732584193, -271733879, null, null, -1009589776]
  ;(m[2] = ~m[0]), (m[3] = ~m[1])
  for (i = 0; i < s.length; i += 16) {
    var o = m.slice(0)
    for (j = 0; j < 80; j++)
      (w[j] =
        j < 16
          ? s[i + j]
          : rol(w[j - 3] ^ w[j - 8] ^ w[j - 14] ^ w[j - 16], 1)),
        (t =
          (rol(m[0], 5) + f[(j / 20) | 0]() + m[4] + w[j] + k[(j / 20) | 0]) |
          0),
        (m[1] = rol(m[1], 30)),
        m.pop(),
        m.unshift(t)
    for (j = 0; j < 5; j++) m[j] = (m[j] + o[j]) | 0
  }
  t = new DataView(new Uint32Array(m).buffer)
  for (var i = 0; i < 5; i++) m[i] = t.getUint32(i << 2)

  var hex = Array.prototype.map
    .call(new Uint8Array(new Uint32Array(m).buffer), function (e) {
      return (e < 16 ? '0' : '') + e.toString(16)
    })
    .join('')
  return hex
}

/*
    @nname  微信签名函数
    @desc   微信签名函数
    @params
            apiList array   需要使用api
*/
const signnure = function (apiList) {
  let noncestr = randomChar();
  let timestamp = new Date().getTime();
  let appId = 'wx807694a528f1e7d5' || store.state.system.signature.app_id;
  let url = isIos() ? window.url : window.location.href;
  let jsapi_ticket = 'bd35b61b4edf9452bdb7726115970a5a' || store.state.system.signature.jsapi_ticket;
  let signature = `jsapi_ticket=${jsapi_ticket}&noncestr=${noncestr}&timestamp=${timestamp}&url=${url}`;
  let options = {
    debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
    appId: appId, // 必填，公众号的唯一标识
    nonceStr: noncestr, // 必填，生成签名的随机串
    timestamp: timestamp, // 必填，生成签名的时间戳
    signature: sha1(signature), // 必填，签名
    jsApiList: apiList // 必填，需要使用的JS接口列表
  }
  return options
}

const sdkService = {
  jssdk_options: {},
  jssdk: async (callback) => {
    let res = await system.jssdk({
      url: window.location.href
    });
    sdkService.jssdk_options = res.data.jsSdk;
    sdkService.jssdk_options.jsApiList = ['onMenuShareTimeline', 'onMenuShareAppMessage'];
    callback();
  },
  config: async function (type) {
    try {
      let apiList
      let menuList = [
        'menuItem:share:qq',
        'menuItem:copyUrl',
        'menuItem:readMode',
        'menuItem:share:QZone',
        'menuItem:share:email',
        'menuItem:share:weiboApp',
        'menuItem:share:facebook',
      ]
      if (type === 'pay') {
        apiList = ['chooseWXPay', 'hideMenuItems', 'showMenuItems']
        menuList.push('menuItem:share:timeline')
        menuList.push('menuItem:share:appMessage')
      } else if (type === 'share') {
        apiList = [
          'hideMenuItems',
          'showMenuItems',
          'onMenuShareTimeline',
          'onMenuShareAppMessage'
        ]
      } else if (type === 'shareTask') {
        apiList = ['hideMenuItems', 'showMenuItems', 'onMenuShareTimeline']
        menuList.push('menuItem:share:appMessage')
      } else if (type === 'location') {
        apiList = ['openLocation']
      } else if (type === 'upDateImg') {
        apiList = ['chooseImage', 'uploadImage', 'getLocalImgData']
      } else {
        apiList = [
          'hideMenuItems',
          'showMenuItems',
          'onMenuShareTimeline',
          'onMenuShareAppMessage',
          'updateAppMessageShareData',
        ]
      }
      if (isFirst && isIos()) {
        isFirst = false;
        window.url = window.location.href
      }
      let options = signnure(apiList)
      wx.config(options);
      wx.ready(function () {
        wx.showMenuItems({
          menuList: ['menuItem:share:appMessage', 'menuItem:share:timeline']
        })
        wx.hideMenuItems({
          menuList
        })
      })
    } catch (err) {
      console.log(err)
    }
  },
  config1: async function () {
    wx.config(sdkService.jssdk_options);
    let id = store.state.user.userInfo.id || 0;
    console.log('link','http://'+location.host+location.pathname+'?user_id='+id);
    let options = {
      title: '习酒大道加油站Q你，点我一起领福利',
      // link: 'http://'+window.host+'/?user_id='+id,
      link: 'http://'+location.host+location.pathname+'?user_id='+id,
      desc: '快来和我一起参与活动，加油更优惠，好福利送给你～',
      imgUrl: 'http://'+window.host+'/upload/1.jpg',
      success: function () {
        console.log('分享成功');
      }
    };
    wx.ready(function () {
      // console.log('配置分享',options);
      wx.onMenuShareTimeline({
        title: options.title,
        link: options.link,
        imgUrl: options.imgUrl,
        success: function () {
        },
        cancel: function () {
        }
      });

      wx.onMenuShareAppMessage({
        title: options.title,
        desc: options.desc,
        link: options.link,
        imgUrl: options.imgUrl,
        success: function () {
        },
        cancel: function () {
        }
      });
    });
  },

  /*
    options: {
        link: link,                         // 分享链接 *
        desc: desc,                         // 分享描述 *
        title: title,                       // 分享标题 *
        imgUrl: imgUrl,                     // 分享封面 *
        cancel: function() {},
        success: function() {},
        type: '',                           // 分享类型,music、video或link，不填默认为link
        dataUrl: '',                        // 如果type是music或video，则要提供数据链接，默认为空
    }
  */
  location: function () {//等我一哈
    wx.ready(function () {
      wx.openLocation({
        latitude: 30.317654, // 纬度，浮点数，范围为90 ~ -90
        longitude: 120.191510, // 经度，浮点数，范围为180 ~ -180。
        name: '位置名', // 位置名
        address: '地址详细说明', // 地址详情说明
        scale: 16, // 地图缩放级别,整形值,范围从1~28。默认为最大
        infoUrl: '' // 在查看位置界面底部显示的超链接,可点击跳转
      });
    });
  },
  share: function (options) {
    // wx.onMenuShareTimeline(options)
    // wx.onMenuShareAppMessage(options)
    console.log('share', options)
    wx.updateAppMessageShareData(options, function (res) {
    });
    wx.updateTimelineShareData(options, function (res) {
    });
  },
  // 默认分享
  defaultShare: function () {
    console.log('默认分享')
    let options = {
      type: '',
      dataUrl: '',
      title: document.title,
      link: window.host + '/?user_id=111',
      desc: '等你来加油',
      imgUrl: `${window.host}/upload/goods/2020-07-09/8ce62c1d66831f6df9affbf9f3d620c2.jpg`
      //imgUrl: 'http://oilapi.yuhongrocky.top/upload/goods/2020-07-09/45289c03736c0b2a45fa9c4b92405ee7.jpg'
    }
    wx.ready(function () {
      wx.onMenuShareTimeline(options)
      wx.onMenuShareAppMessage(options)
    })
  },
  /*
    options: {
        timeStamp: 0,                   // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
        nonceStr: '',                   // 支付签名随机串，不长于 32 位
        package: '',                    // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
        signType: '',                   // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
        paySign: '',                    // 支付签名
        success: function(res) {}
    }
  */
  pay: function (options) {
    wx.chooseWXPay({
      timestamp: options.timeStamp,
      nonceStr: options.nonceStr,
      signType: options.signType,
      package: options.package,
      paySign: options.paySign,
      success: function (res) {
        options.success(res)
      },
      fail: function (res) {
      }
    })
  }
}

wx.error(function (res) {
  console.log(res)
});

export default sdkService



// WEBPACK FOOTER //
// ./src/service/sdkService.js